import React from 'react'

export default function BuyNowButtonGreyed() {
  return (
    <button className="w-full h-10 p-2 mr-4 bg-gray-300 text-gray-50 cursor-not-allowed">
        Out of Stock
    </button>  
    )
}
